export class BaseRepository {

    getUrl(path: string) {
        return process.env.VUE_APP_API_URL + path;
    }

}
